import React, { useEffect, useRef } from "react";
import ScrollToTop from "../components/ScrollToTop";
import HelmetComponent from "../components/Helmet";

const TermsConditions = () => {
    const TermsConditionSection = useRef(null);

    useEffect(() => {
        if (TermsConditionSection.current) {
            TermsConditionSection.current.scrollIntoView({ behavior: "smooth" });

            // Thoda upar shift karne ke liye
            setTimeout(() => {
                window.scrollBy({ top: -100, left: 0, behavior: "smooth" });
            }, 500); // 500ms delay tak scroll hone de
        }
    }, []);
    return (
        <>
            <div className="max-md:px-4 lg:px-5 xl:px-5 py-4 scroll-mt-[90px]" ref={TermsConditionSection}>
                <HelmetComponent
                    title="Terms & Conditions | Shri Radhe Holidays"
                    description="Read the terms and conditions of Shri Radhe Holidays regarding tour bookings, cancellations, payments, refunds, travel policies, hotel reservations and travel services."
                    url="https://www.shriradheholidays.com/termsconditions"
                />

                <h1 className="playfair-display font-extrabold py-[6px] px-2 max-sm:text-xl xl:text-2xl text-white  text-start border-l-8 rounded-r-full bg-[#0B1C3D]  border-[#D4AF37] wow fadeInUp max-sm:w-[70%] xl:w-[50%] transform -skew-x-12"
                    style={{ boxShadow: ' 0px 0px 20px 5px  rgb(0 0 0 / 32%)' }}
                >
                    Terms & Conditions
                </h1>
                <div className="max-md:px-3 lg:px-3 xl:px-3">
                    {/* <h1 className="mb-4" style={{ fontWeight: "bolder" }}>Our Terms & Conditions</h1> */}
                    <p className="mb-4 mt-4 text-justify">
                        Welcome to <strong className="text-[#D4AF37]">Shri Radhe Holidays</strong>. By accessing our website and using our services, you agree to comply with the following terms and conditions. Please read them carefully before making any bookings.
                    </p>

                    <h3 className="h4 mb-3" style={{ fontWeight: "bolder" }}>1. Booking & Payments</h3>
                    <ul style={{ marginBottom: "3rem", paddingLeft: "20px", listStyleType: "disc" }}>
                        <li>All bookings require full or partial payment to confirm reservations.</li>
                        <li>Prices are subject to availability and may change without prior notice.</li>
                        <li>Payments must be made through approved methods listed on our website.</li>
                    </ul>

                    <h3 className="h4 mb-3" style={{ fontWeight: "bolder" }}>2. Cancellations & Refunds</h3>
                    <ul style={{ marginBottom: "3rem", paddingLeft: "20px", listStyleType: "disc" }}>
                        <li>Cancellations are subject to our refund policy, based on the time of request.</li>
                        <li>Refunds will be processed within 7-10 working days.</li>
                        <li>Some bookings may be non-refundable, as specified at the time of booking.</li>
                    </ul>

                    <h3 className="h4 mb-3" style={{ fontWeight: "bolder" }}>3. User Responsibilities</h3>
                    <ul style={{ marginBottom: "3rem", paddingLeft: "20px", listStyleType: "disc" }}>
                        <li>Users must provide accurate and complete information when booking.</li>
                        <li>Users are responsible for complying with visa and travel regulations.</li>
                        <li>Any fraudulent activity may result in termination of services.</li>
                    </ul>

                    <h3 className="h4 mb-3" style={{ fontWeight: "bolder" }}>4. Liability Disclaimer</h3>
                    <p className="mb-4 text-justify">
                        Shri Radhe Holidays is not responsible for delays, cancellations, or unforeseen circumstances caused by airlines, hotels, or other service providers.
                    </p>

                    <h3 className="h4 mb-3" style={{ fontWeight: "bolder" }}>5. Changes to Terms</h3>
                    <p className="mb-4 text-justify">
                        We reserve the right to modify these terms at any time. Continued use of our services implies acceptance of any updated terms.
                    </p>

                    {/* Footer Section */}
                    {/* <div className="text-center mt-8">
                        <p className="dancing-script-font text-4xl md:text-6xl text-[#86B817] ">
                            Shri Radhe Holidays
                        </p>
                        <p className="text-sm md:text-lg hanuman-regular">
                            Where Every Trip Feels Divine.
                        </p>
                    </div> */}
                </div>
            </div>
            <ScrollToTop />
        </>
    );
};

export default TermsConditions;